import { IOutputSensorTypeResponse } from '@kcftech/prometheus-client';
import { Dropdown, DropdownLabelRenderer } from 'components/dropdown/Dropdown';
import { formatSensorRole } from 'pages/Settings/ThirdPartySensorModels/shared';
import { dropdownTriggerStyles } from 'pages/Settings/ThirdPartySensorModels/styled';
import { useOutputDataStreamTypes } from 'pages/Settings/ThirdPartySensorModels/useOutputDataStreamTypes';
import { tokens } from 'styles/tokens';
import { insertSpacesOnCaseChange } from 'utils/string';

const renderItem = (item: IOutputSensorTypeResponse) =>
    `${insertSpacesOnCaseChange(item.CommonType)}, ${formatSensorRole(item.RoleCode)}`;

const renderLabel: DropdownLabelRenderer<IOutputSensorTypeResponse> = ({
    value,
    isDisabled,
}) => {
    if (!value) {
        return (
            <div title={isDisabled ? 'Select a Data Type to enable' : undefined}>
                Select an output data stream type
            </div>
        );
    }

    return <div>{renderItem(value)}</div>;
};

export type OutputDataStreamTypeDropdownProps = Readonly<{
    dataTypeId?: number;
    value: IOutputSensorTypeResponse | undefined;
    onChange: (newValue: IOutputSensorTypeResponse | undefined) => void;
}>;

export function OutputDataStreamTypeDropdown({
    dataTypeId,
    value,
    onChange,
}: OutputDataStreamTypeDropdownProps) {
    const { data } = useOutputDataStreamTypes({ dataTypeId });

    return (
        <Dropdown<IOutputSensorTypeResponse>
            isDisabled={dataTypeId === undefined}
            trigger={{
                style: {
                    ...dropdownTriggerStyles,
                    backgroundColor: tokens.grey.light,
                    border: `2px solid ${tokens.border.default}`,
                },
            }}
            dataKey={(item) => `${item.CommonType}-${item.RoleCode}`}
            data={data}
            value={value}
            renderItem={({ item }) => renderItem(item)}
            renderLabel={renderLabel}
            onChange={onChange}
        />
    );
}
